import { type Nationality } from "@/types/nationality";

export type NationalityId = number | string | null | undefined;

export const normalizeCountryCode = (code: string | null | undefined) =>
  (code ?? "").trim().toUpperCase();

export const normalizeNationalityId = (id: NationalityId) =>
  String(id ?? "").trim();

export const findNationalityByCode = (
  nationalities: Nationality[],
  code: string | null | undefined,
) => {
  const normalizedCode = normalizeCountryCode(code);
  if (!normalizedCode) {
    return undefined;
  }

  return nationalities.find(
    (nationality) => normalizeCountryCode(nationality.code) === normalizedCode,
  );
};

export const findNationalityById = (
  nationalities: Nationality[],
  id: NationalityId,
) => {
  const normalizedId = normalizeNationalityId(id);
  if (!normalizedId) {
    return undefined;
  }

  return nationalities.find(
    (nationality) => normalizeNationalityId(nationality.id) === normalizedId,
  );
};

export const resolveNationality = (
  nationalities: Nationality[],
  {
    code,
    id,
  }: {
    code?: string | null;
    id?: NationalityId;
  },
) => {
  return (
    findNationalityByCode(nationalities, code) ??
    findNationalityById(nationalities, id)
  );
};
